import { render, staticRenderFns } from "./Getcoach.vue?vue&type=template&id=4a25a89f&scoped=true"
import script from "./Getcoach.vue?vue&type=script&lang=js"
export * from "./Getcoach.vue?vue&type=script&lang=js"
import style0 from "./Getcoach.vue?vue&type=style&index=0&id=4a25a89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25a89f",
  null
  
)

export default component.exports